import { authToken, getAuthToken, user_object } from './authToken';
import Constants from "expo-constants";
import { upsertSurveyQuestionsParams } from './ApiClientTypes';
import { Survey } from '../../models/types';
const { manifest } = Constants;


const BASE_URL =
    // 'http://localhost:3000'
    // http://${manifest.debuggerHost.split(':').shift()}:3000
    'https://calm-mesa-16511.herokuapp.com'
;



export class Response {
    error: any;
    data: any;
    constructor(error: any, data: any) {
        this.error = error;
        this.data = data;
    }
}


class ClientApi {
    // login the user and get a token
    async loginAndGetToken(username: string, password: string) {
        try {
            const authTokenResponse = await getAuthToken({ email: username, password: password });
            console.log('loginAndGetToken() getAuthToken response = ', authTokenResponse);
            if (authTokenResponse.output && authTokenResponse.output.payload) {
                return new Response(
                    authTokenResponse.output.payload,
                    undefined
                );
            }
            else {
                return new Response(
                    undefined,
                    authTokenResponse
                );
            }
        }
        catch (error) {
            console.log('ERROR signIn', error);
            return {
                error: error,
                data: undefined
            }
        }
    }


    // login the user and get a token
    async createUser(username: string, password: string, email: string, plan_id: number) {
        try {
            const url = BASE_URL + '/auth_poall/register-user';
            const requestConfig = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                body: JSON.stringify({ username, email, password, plan_id }),
            }

            const response = await fetch(url, requestConfig);
            console.log('  createUser response', response);



            if (response && response.ok) {
                return new Response(
                    undefined,
                    response
                );
            }
            else {
                const jsonData = await response.json(); // parses response to JSON
                console.log('  jsonData', jsonData);
                return new Response(
                    jsonData.output.payload,
                    undefined
                );
            }
        }
        catch (error) {
            console.log('error creating user', error);
            return new Response('Unable to create user, please try again', undefined); 
        }
    }

    // submit anon or user survey answers
    async createSurveyUserAnswers(data: { user_answers: [{ survey_id: string; question_id: string; answer_id: string; answer_bool: string; answer_numeric: string; answer_text: string; user_id?: string; }] }) {
        try {
            const url = BASE_URL + '/poall_mutations/post-survey-answers';
            const response = await fetchWithToken(url, data);
            console.log('createSurveyUserAnswers response', { url, response });
            if (response.ok) {
                const jsonData = await response.json();
                return new Response(jsonData.error, jsonData.data);
            }
            else {
                return new Response('Unable to send answers, please try again', undefined);
            }
        }
        catch (error) {
            console.log('error creating user answers', error);
            return new Response('Unable to send answers, please try again', undefined);
        }
    }

    // create a Survey questions
    async upsertSurveyQuestions(data: upsertSurveyQuestionsParams) {
        try {
            const url = BASE_URL + '/poall_mutations/post-upsert-survey-sections';
            const response = await fetchWithToken(url, data);
            console.log('createSurveyUserAnswers response', { url, response });
            if (response.ok) {
                const jsonData = await response.json();
                return new Response(jsonData.error, jsonData.data);
            }
            else {
                return new Response('Unable to udpate survey, please try again', undefined);
            }
        }
        catch (error) {
            console.log('error creating survey', error);
            return new Response('Unable to update survey, please try again', undefined);
        }
    }

    // create a Poll question
    async upsertPollQuestion(data: upsertSurveyQuestionsParams) {
        try {
            const url = BASE_URL + '/poall_mutations/post-upsert-poll-sections';
            const response = await fetchWithToken(url, data);
            console.log('upsertPollQuestion response', { url, response });
            if (response.ok) {
                const jsonData = await response.json();
                return new Response(jsonData.error, jsonData.data);
            }
            else {
                return new Response('Unable to update poll, please try again', undefined);
            }
        }
        catch (error) {
            console.log('error creating user answers', error);
            return new Response('Unable to update poll, please try again', undefined);
        }
    }

    // create a Survey (or Poll)
    async upsertSurvey(data: Survey) {
        try {
            const url = BASE_URL + '/poall_mutations/post-upsert-survey';
            const response = await fetchWithToken(url, data);
            console.log('upsertSurvey response', { url, response });
            if (response.ok) {
                const jsonData = await response.json();
                return new Response(jsonData.error, jsonData.data);
            }
            else {
                return new Response('Unable to update poll, please try again', undefined);
            }
        }
        catch (error) {
            console.log('error creating user answers', error);
            return new Response('Unable to update poll, please try again', undefined);
        }
    }
}


export const ApiClient = new ClientApi();






export async function fetchWithToken(url: string, data: any, callType?: 'POST' | 'GET'): Promise<any> {
    const requestOptions = {
        method: callType || 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + authToken,
            'x-hasura-role': user_object?.product_plan?.title
        },
        body: JSON.stringify(data)
    };
    console.log('fetch with token', url, requestOptions)
    return fetch(url, requestOptions);
}

export async function fetchWithoutToken(url: string, data: any, callType?: 'POST' | 'GET'): Promise<any> {
    const requestOptions = {
        method: callType || 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    };
    return fetch(url, requestOptions);
}


